import {Button, Theme} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import {SystemStyleObject} from "@mui/system/styleFunctionSx/styleFunctionSx";

const HeaderButton = ({text, path, sx}: { text: string; path: string; sx?: SystemStyleObject<Theme> }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname.includes(path);
  return (
    <Button
      onClick={() => navigate(path)}
      sx={(theme) => ({
        ...sx,
        ...theme.typography.h7,
        p: 2.5,
        backgroundColor: isActive ? '#fff' : 'rgba(255, 255, 255, 0.30)',
        borderRadius: 3,
        color: isActive ? 'black.100' : 'white',
        flex: {md: 1},
        maxWidth: {lg: 210}
      })}>
      {text}
    </Button>
  )
}

export default HeaderButton
